export enum Roles {
  Admin = 'admin',
  Common = 'common',
  Company = 'company',
  Company_alias = 'company_alias',
  Not_set = 'not_set',
  Supervisor = 'supervisor'
}
